//===================================================================================================
//===================================================================================================
//===============> QUIZ RESPONSE PAGE


quizResponse = (() => {

  const quizID = document.getElementById("quiz-nine");
  const quizContainer = document.getElementById("quiz-container");
  
    const createResultsContainer = document.createElement("div");
    createResultsContainer.setAttribute("id",'quiz-response');
    createResultsContainer.classList.add("full-screen", "response-style");
    createResultsContainer.style.marginLeft = "200vw";
  
      const containerTop = document.createElement("div");
      containerTop.classList.add("re-top");
      const containerLeft = document.createElement("div");
      containerLeft.classList.add("re-left");
      const containerRight = document.createElement("div");
      containerRight.classList.add("re-right");
      const containerBottom = document.createElement("div");
      containerBottom.classList.add("re-bottom");
      
      //====> CREATE PROGRAM LINK ENDPOINT
      let endpoint = ResponseSeven.response.toLowerCase();
      if ( endpoint === "model") {
        endpoint = `https://momomuscle.co/products/${endpoint}-program`;
      } else {
        endpoint = `https://momomuscle.co/products/the-${endpoint}-program`;
      }
    
    //============>  Top Container
      
        const createHeroContainer = document.createElement("div");
        createHeroContainer.setAttribute("id", 'response-hero');

          const createConfettiCanvas = document.createElement("canvas");
          createConfettiCanvas.setAttribute("id", 'confetti-canvas');
        createHeroContainer.appendChild(createConfettiCanvas);
  
          //====> Add Header Section
          const createHeaderSection = document.createElement("div");
          createHeaderSection.classList.add("two-box-grid");
        
            //==> Header Image Section 
            const createHeroImgSection = document.createElement("div");
            createHeroImgSection.classList.add("box", 'image');
  
            //===> 'Your results are in!' 
              const createMobileIntro = document.createElement("h3");
              createMobileIntro.classList.add("hero",'mobile-block');
                const createMobileIntroText = document.createTextNode(`Your results are in!`);
              createMobileIntro.appendChild(createMobileIntroText);  
            createHeroImgSection.appendChild(createMobileIntro);
  
              const createHeroImg = document.createElement("img");
              createHeroImg.src = `${ResponseSeven.image}`;
        
            createHeroImgSection.appendChild(createHeroImg);  
          createHeaderSection.appendChild(createHeroImgSection);
            
            //==> Create Header Text Section 
            const createHeaderTextSection = document.createElement("div");
            createHeaderTextSection.classList.add("box", 'text');
    
            //===> 'Your results are in!' 
              const createIntro = document.createElement("h3");
              createIntro.classList.add("hero",'desktop-block');
                const createIntroText = document.createTextNode(`Your results are in!`);
              createIntro.appendChild(createIntroText);  
            createHeaderTextSection.appendChild(createIntro);
      
            //===> 'the' 
            const theTitle = document.createElement("h2");
              theTitle.classList.add("hero");
                const theText = document.createTextNode(`the`);
              theTitle.appendChild(theText);
            createHeaderTextSection.appendChild(theTitle);
      
            //===> 'Program Title' 
              const programTitle = document.createElement("h1");
              programTitle.classList.add("hero");
                const progText = document.createTextNode(`${ResponseSeven.response}`);
              programTitle.appendChild(progText);
            createHeaderTextSection.appendChild(programTitle);
       
          createHeaderSection.appendChild(createHeaderTextSection);
        createHeroContainer.appendChild(createHeaderSection);
      containerTop.appendChild(createHeroContainer); 
      
        //====> Add Programs Section
        const createProgramContainer = document.createElement("div");
          createProgramContainer.setAttribute("id", 'response-program');
          const createProgramSection = document.createElement("div");
    
          createProgramSection.classList.add("two-box-grid");
        
            //==> Program Image Section  
            const createProgramImgSection = document.createElement("div");
            createProgramImgSection.classList.add("box", 'image');
      
              const createImg = document.createElement("img");
              createImg.src = `${ResponseSeven.productImg}`;
      
            createProgramImgSection.appendChild(createImg);
          createProgramSection.appendChild(createProgramImgSection);
        
            //==> Program Text Section  
            const createProgramTextSection = document.createElement("div"); 
            createProgramTextSection.classList.add("box", 'text');
      
              // Program Text Section Title
              const createProgramTitle = document.createElement("h2");
                const createProgramTitleText = document.createTextNode(`the ${ResponseSeven.response} Program`);
              createProgramTitle.appendChild(createProgramTitleText);
            createProgramTextSection.appendChild(createProgramTitle);
        
              // Program Text Section Paragraph
              const createProgramParagraph = document.createElement("p");
                const createProgramParagraphText = document.createTextNode(`${ResponseSeven.horoscope}`);
              createProgramParagraph.appendChild(createProgramParagraphText);
            createProgramTextSection.appendChild(createProgramParagraph);
        
              // Program Text Section Checklist
              const createChecklist = document.createElement("ul");
                let cl = ResponseSeven.bulletPoints.map((m,k) => {
                  const listItem = document.createElement("li");
                    const plusSpan = document.createElement("span");
                    const plusSign = document.createTextNode(`+`);
                    plusSpan.appendChild(plusSign);
                  listItem.appendChild(plusSpan);
                    const liText = document.createTextNode(`${m}`);
                  listItem.appendChild(liText);
                  createChecklist.appendChild(listItem);
                });
              createProgramTextSection.appendChild(createChecklist);
      
              // Program Text Section Mobile Image
              const createProgramMobileImg = document.createElement("img");
              createProgramMobileImg.classList.add("mobile-image", 'mobile'); 
              createProgramMobileImg.src = `${ResponseSeven.productImg}`;
              createProgramMobileImg.alt = `${ResponseSeven.response}`;
      
            createProgramTextSection.appendChild(createProgramMobileImg);
      
                // Program Text Section CTA
              const createProgramCTA = document.createElement("a");
              createProgramCTA.setAttribute("href", `${endpoint}`);
              createProgramCTA.setAttribute("target", '_blank');
              createProgramCTA.classList.add("cta");
      
                const createCTASpan = document.createElement("span");
                  const createProgramCTAText = document.createTextNode(`Become a ${ResponseSeven.response}`);
                createCTASpan.appendChild(createProgramCTAText);
              createProgramCTA.appendChild(createCTASpan);
    
                const createSVGcontainer = document.createElement("div");
                createSVGcontainer.classList.add("icon-arrow-button", 'icon-circle');
                createSVGcontainer.style.backgroundColor = "#FFF";
                  const xmlns = "http://www.w3.org/2000/svg";
                  const boxWidth = 14;
                  const boxHeight = 10;
                
                  const createSVG = document.createElementNS(xmlns, 'svg');
                  createSVG.setAttributeNS(null, "viewBox", '0 0 ' + boxWidth + ' ' + boxHeight);
                  createSVG.setAttributeNS(null, "width", '100%');
                  createSVG.style.display = "block";
            
            
                  var pathSVG = document.createElementNS(xmlns, "path");
                  pathSVG.setAttributeNS(null, "d", `M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z`);
                createSVG.appendChild(pathSVG);
                
              createSVGcontainer.appendChild(createSVG);
            createProgramCTA.appendChild(createSVGcontainer);
          createProgramTextSection.appendChild(createProgramCTA);
      
          createProgramSection.appendChild(createProgramTextSection);
        createProgramContainer.appendChild(createProgramSection);
      containerTop.appendChild(createProgramContainer);
    
    //============>  Left Container  
      
        //====> Add Hormones Title
        const createHormonesTitle = document.createElement("h1");
        const createHormonesText = document.createTextNode(`HORMONES`);
        createHormonesTitle.appendChild(createHormonesText);
        containerLeft.appendChild(createHormonesTitle);
      
        const createHormonesSubtitle = document.createElement("h5");
        const createHormonesSubText = document.createTextNode(`and what they say about you`);
        createHormonesSubtitle.appendChild(createHormonesSubText);
        containerLeft.appendChild(createHormonesSubtitle);
      
      if (ResponseOne.response !== "" ) {
        const reOne = document.createElement("div");
        reOne.classList.add("re-div", "re-one");
        const createSectionOne = document.createElement("section");
        const createSectionTwo = document.createElement("section");
        
        const createImg = document.createElement("img");
        createImg.src = `${ResponseOne.icon}`;
        createSectionOne.appendChild(createImg);
        
        const createHeaderSection = document.createElement("h3");
        const createHeaderSectionText = document.createTextNode(`${ResponseOne.option}`);
        createHeaderSection.appendChild(createHeaderSectionText);
        createSectionTwo.appendChild(createHeaderSection);
        
        const createParagraph = document.createElement("p");
        const createParagraphText = document.createTextNode(`${ResponseOne.response}`);
        createParagraph.appendChild(createParagraphText);
        createSectionTwo.appendChild(createParagraph);
    
        reOne.appendChild(createSectionOne);
        reOne.appendChild(createSectionTwo);
        
      containerLeft.appendChild(reOne);
      }
      if (ResponseTwo.response !== "" ) {
        const reTwo = document.createElement("div");
        reTwo.classList.add("re-div", "re-two");
        const createSectionOne = document.createElement("section");
        const createSectionTwo = document.createElement("section");
        
        const createImg = document.createElement("img");
        createImg.src = `${ResponseTwo.icon}`;
        createSectionOne.appendChild(createImg);
        
        const createHeaderSection = document.createElement("h3");
        const createHeaderSectionText = document.createTextNode(`${ResponseTwo.option}`);
        createHeaderSection.appendChild(createHeaderSectionText);
        createSectionTwo.appendChild(createHeaderSection);
        
        const createParagraph = document.createElement("p");
        const createParagraphText = document.createTextNode(`${ResponseTwo.response}`);
        createParagraph.appendChild(createParagraphText);
        createSectionTwo.appendChild(createParagraph);
    
        reTwo.appendChild(createSectionOne);
        reTwo.appendChild(createSectionTwo);
        
      containerLeft.appendChild(reTwo);
     }
      console.log( "re-three", ResponseThree);
      if (ResponseThree.response !== "" ) {
        const reThree = document.createElement("div");
        reThree.classList.add('re-div', 're-three');
        const createSectionOne = document.createElement("section");
        const createSectionTwo = document.createElement("section");
        
        const createImg = document.createElement("img");
        createImg.src = `${ResponseThree.icon}`;
        createSectionOne.appendChild(createImg);
        
        const createHeaderSection = document.createElement("h3");
        const createHeaderSectionText = document.createTextNode(`${ResponseThree.option}`);
        createHeaderSection.appendChild(createHeaderSectionText);
        createSectionTwo.appendChild(createHeaderSection);
        
        const createParagraph = document.createElement("p");
        const createParagraphText = document.createTextNode(`${ResponseThree.response}`);
        createParagraph.appendChild(createParagraphText);
        createSectionTwo.appendChild(createParagraph);
    
        reThree.appendChild(createSectionOne);
        reThree.appendChild(createSectionTwo);
        
      containerLeft.appendChild(reThree);   
      }
    
    //============>  Right Container  
      //====> Add Nutrition Title
        const createNutritionTitle = document.createElement("h1");
        const createNutritionText = document.createTextNode(`NUTRITION`);
        createNutritionTitle.appendChild(createNutritionText);
        containerRight.appendChild(createNutritionTitle);
    
        const createNutritionSubtitle = document.createElement("h5");
        const createNutritionSubText = document.createTextNode(`and why it matters`);
        createNutritionSubtitle.appendChild(createNutritionSubText);
        containerRight.appendChild(createNutritionSubtitle);
      
      if (ResponseFour.response !== "" ) {
        const reFour = document.createElement("div");
        reFour.classList.add("re-div", "re-four");
        const createSectionOne = document.createElement("section");
        const createSectionTwo = document.createElement("section");
        
        const createImg = document.createElement("img");
        createImg.src = `${ResponseFour.icon}`;
        createSectionOne.appendChild(createImg);
        
        const createHeaderSectionThree = document.createElement("h3");
        const createHeaderSectionText = document.createTextNode(`${ResponseFour.option}`);
        createHeaderSectionThree.appendChild(createHeaderSectionText);
        createSectionTwo.appendChild(createHeaderSectionThree);
        
        const createParagraph = document.createElement("p");
        const createParagraphText = document.createTextNode(`${ResponseFour.response}`);
        createParagraph.appendChild(createParagraphText);
        createSectionTwo.appendChild(createParagraph);
    
        reFour.appendChild(createSectionOne);
        reFour.appendChild(createSectionTwo);
        containerRight.appendChild(reFour);
      }
      if (ResponseFive.response !== "" ) {
        const reFive = document.createElement("div");
        reFive.classList.add("re-div", "re-five");
        const createSectionOne = document.createElement("section");
        const createSectionTwo = document.createElement("section");
        
        const createImg = document.createElement("img");
        createImg.src = `${ResponseFive.icon}`;
        createSectionOne.appendChild(createImg);
        
        const createHeaderSectionThree = document.createElement("h3");
        const createHeaderSectionText = document.createTextNode(`${ResponseFive.option}`);
        createHeaderSectionThree.appendChild(createHeaderSectionText);
        createSectionTwo.appendChild(createHeaderSectionThree);
        
        const createParagraph = document.createElement("p");
        const createParagraphText = document.createTextNode(`${ResponseFive.response}`);
        createParagraph.appendChild(createParagraphText);
        createSectionTwo.appendChild(createParagraph);
    
        reFive.appendChild(createSectionOne);
        reFive.appendChild(createSectionTwo);
        containerRight.appendChild(reFive);
      }
      if (ResponseFive.response == "" ) {
        const reFive = document.createElement("div");
        const createHeaderSectionTwo = document.createElement("h2");
        const createHeaderSectionText = document.createTextNode(`${ResponseFive.option}`);
        createHeaderSectionTwo.appendChild(createHeaderSectionText);
        reFive.appendChild(createHeaderSectionTwo);
    
        const createParagraph = document.createElement("p");
        const createParagraphText = document.createTextNode(`GREAT JOB, you are on the right track`);
        createParagraph.appendChild(createParagraphText);
        reFive.appendChild(createParagraph);
        
        containerRight.appendChild(reFive);    
      }
    
      //====> Add Training Title
        const createTrainingTitle = document.createElement("h1");
        createTrainingTitle.classList.add('training-title');
        const createTrainingText = document.createTextNode('TRAINING');
        createTrainingTitle.appendChild(createTrainingText);
        containerRight.appendChild(createTrainingTitle);
      
        const createTrainingSubtitle = document.createElement("h5");
        const createTrainingSubText = document.createTextNode(`and why you need it`);
        createTrainingSubtitle.appendChild(createTrainingSubText);
        containerRight.appendChild(createTrainingSubtitle);
      
      if (ResponseSix.response !== "" && ResponseSix.qNum == "one") {
    
        const reSix = document.createElement("div");
        reSix.classList.add("re-div", "re-six");
        reSix.classList.add("re-six");
        
        const createSectionOne = document.createElement("section");
        const createSectionTwo = document.createElement("section");
        
        const createImg = document.createElement("img");
        createImg.src = `${ResponseSix.icon}`;
        createSectionOne.appendChild(createImg);
        
        const createHeaderSectionThree = document.createElement("h3");
        const createHeaderSectionThreeText = document.createTextNode(`${ResponseSix.option}`);
        createHeaderSectionThree.appendChild(createHeaderSectionThreeText);
        createSectionTwo.appendChild(createHeaderSectionThree);
        
        const createParagraph = document.createElement("p");
        const createParagraphText = document.createTextNode(`${ResponseSix.response}`);
        createParagraph.appendChild(createParagraphText);
        createSectionTwo.appendChild(createParagraph);
    
        reSix.appendChild(createSectionOne);
        reSix.appendChild(createSectionTwo);
        containerRight.appendChild(reSix);
      } 
      if (ResponseSix.response !== "" && ResponseSix.qNum != "one") {
    
        const reSix = document.createElement("div");
        reSix.classList.add("re-div", "re-six");
        
        const createSectionOne = document.createElement("section");
        const createSectionTwo = document.createElement("section");
        
        const createImg = document.createElement("img");
        createImg.src = "https://cdn.shopify.com/s/files/1/0017/7533/7583/files/balance.png?v=1602375331";
        createSectionOne.appendChild(createImg);
        
        const createHeaderSectionThree = document.createElement("h3");
        const createHeaderSectionThreeText = document.createTextNode(`That Movement Tho`);
        createHeaderSectionThree.appendChild(createHeaderSectionThreeText);
        createSectionTwo.appendChild(createHeaderSectionThree);
        
        const createParagraph = document.createElement("p");
        const createParagraphText = document.createTextNode(`Looks like your training routine is awesome! You know what you're doing - but we can see even more results by refining that movement quality with some key tweaks.`);
        createParagraph.appendChild(createParagraphText);
        createSectionTwo.appendChild(createParagraph);
    
        reSix.appendChild(createSectionOne);
        reSix.appendChild(createSectionTwo);
        containerRight.appendChild(reSix);
      }
    
    //============>  Bottom Container  
      if (
        ResponseFour.qNum === "two" ||
        ResponseFour.qNum === "three" ||
        ResponseFive.qnum === "one" ||
        ResponseFive.qnum === "three" ||
        ResponseFive.qnum === "five"
      ) {
        const reResponse = document.createElement("div");
        reResponse.classList.add("re-response");
        
        const createSectionOne = document.createElement("section");
        const createSectionTwo = document.createElement("section");
        
          const createImgH = document.createElement("img");
          createImgH.src = `${headshot}`;
          createImgH.setAttribute("id", 'response-headshot');
        createSectionOne.appendChild(createImgH);
          
          const createImgS = document.createElement("img");
          createImgS.src = `${signature}`;
          createImgS.setAttribute("id", 'response-signature');
        createSectionOne.appendChild(createImgS);
        
        const createHeaderSectionThree = document.createElement("h3");
        const createHeaderSectionThreeText = document.createTextNode(`MAKE EVERY REP COUNT`);
        createHeaderSectionThree.appendChild(createHeaderSectionThreeText);
        createSectionTwo.appendChild(createHeaderSectionThree);
        
          const createParagraph = document.createElement("p");
            const documentFragment = document.createDocumentFragment();
        
            const createParagraphTextOne = document.createTextNode(`Did you know muscle burns more calories than fat and takes up way less space? We are going to hack your meal frequency, protein intake, gut health, and training methods to get you stronger, yet leaner. I recommend following `);
            documentFragment.appendChild(createParagraphTextOne);
        
            const programLink = document.createElement("a");
            programLink.setAttribute("href", `${endpoint}`);
            programLink.setAttribute("id", 'quiz-program-link');
            programLink.setAttribute("target", '_blank'); 
              const createLinkText = document.createTextNode(`The ${ResponseSeven.response} Program`);
              programLink.appendChild(createLinkText);
            documentFragment.appendChild(programLink);
        
            const createParagraphTextTwo = document.createTextNode(` to get that bod you've been dreaming of.`);
            documentFragment.appendChild(createParagraphTextTwo);
      
            createParagraph.appendChild(documentFragment);
          createSectionTwo.appendChild(createParagraph);
        
        reResponse.appendChild(createSectionOne);
        reResponse.appendChild(createSectionTwo);
        containerBottom.appendChild(reResponse);
    
      } else {
        const reResponse = document.createElement("div");
        reResponse.classList.add("re-response");
        
        const createSectionOne = document.createElement("section");
        const createSectionTwo = document.createElement("section");
        
        const createImgH = document.createElement("img");
        createImgH.src = `${headshot}`;
        createImgH.setAttribute("id", 'response-headshot');
        createSectionOne.appendChild(createImgH);
        
        const createImgS = document.createElement("img");
        createImgS.src = `${signature}`;
        createImgS.setAttribute("id", 'response-signature');
        createSectionOne.appendChild(createImgS);
        
        const createHeaderSectionThree = document.createElement("h3");
          const createHeaderSectionThreeText = document.createTextNode(`MUSCLE UP YOUR METABOLISM`);
        createHeaderSectionThree.appendChild(createHeaderSectionThreeText);        
      createSectionTwo.appendChild(createHeaderSectionThree);
        
          const createParagraph = document.createElement("p");
            const documentFragment = document.createDocumentFragment();
    
            const createParagraphTextOne = document.createTextNode(`It's the science.  I am all about working smart and hard for optimal results, in less time.  Up your fitness game with `);
            documentFragment.appendChild(createParagraphTextOne);
        
            const programLink = document.createElement("a");
            programLink.setAttribute("href", `${endpoint}`);
            programLink.setAttribute("id", 'quiz-program-link'); 
            programLink.setAttribute("target", '_blank'); 
              const createLinkText = document.createTextNode(`The ${ResponseSeven.response} Program`);
              programLink.appendChild(createLinkText);
            documentFragment.appendChild(programLink);
        
            const createParagraphTextTwo = document.createTextNode(`, I know you'll love it!`);
            documentFragment.appendChild(createParagraphTextTwo);
        
          createParagraph.appendChild(documentFragment);
        createSectionTwo.appendChild(createParagraph);
        
        reResponse.appendChild(createSectionOne);
        reResponse.appendChild(createSectionTwo);
        containerBottom.appendChild(reResponse);
      }
    
      
      //========> CREATE CTA PROGRAM LINK  
        //====> CREATE LINK BUTTON ELEMENT "a"
        const createProgramLink = document.createElement("a");
        createProgramLink.setAttribute("href", `${endpoint}`);
        createProgramLink.setAttribute("id", `${ResponseSeven.response}-link`);
        createProgramLink.setAttribute("target", '_blank');  
        createProgramLink.classList.add('custom-button', 'a-btn'); 
          //==> CREATE LINK INNER CONTENT
          const linkFragment = document.createElement("span");
            // BUTTON TEXT
              let createCTAText = document.createTextNode(`Become a ${ResponseSeven.response}`);
            linkFragment.appendChild(createCTAText);
          // linkFragment.appendChild(createCTAButton)    
        createProgramLink.appendChild(linkFragment);  
      //====> ADD LINK TO BOTTOM CONTAINER
      containerBottom.appendChild(createProgramLink);
    
      
      //========>  CREATE TESTIMONIALS BANNER FOR RESPONSE PAGE
      const createTesimonialsBanner = document.createElement("div");
      containerBottom.setAttribute("id", 'response-testimonials');
      containerBottom.classList.add("three-columns-container");
      
        const createTestimonialsContainer = document.createElement("div");
        createTestimonialsContainer.classList.add("testimonials", "grid-container");
    
          //======> CREATE TESIMONIALS LIST
          var mapTestimonials = ResponseSeven.reviews.map((review)=>{
          //   //====> CREATE TESIMONIALS COLUMN CARD
            const createTestimonialsColumn = document.createElement("div");
            createTestimonialsColumn.classList.add("column");
            
          //   //====> CREATE TESIMONIALS COLUMN CARD INNER DIV
              const createTestimonialsColumnDiv = document.createElement("div");
            
          //       //==> CREATE TOP DIV FOR IMAGE
                const createReviewTop = document.createElement("div");
                  const createReviewsImage = document.createElement("img");
                  createReviewsImage.classList.add("image");
                  createReviewsImage.src = `${review.img}`;
                  createReviewsImage.alt = `reviewer image`;
                createReviewTop.appendChild(createReviewsImage);
              createTestimonialsColumnDiv.appendChild(createReviewTop);
            
          //       //==> CREATE BOTTOM DIV FOR TEXT
                const createReviewBottom = document.createElement("div");  
                  const createReviewParagraph = document.createElement("p");            
                    let createTestimonialsText = document.createTextNode(`${review.txt}`); 
                  createReviewParagraph.appendChild(createTestimonialsText);
                createReviewBottom.appendChild(createReviewParagraph);
              createTestimonialsColumnDiv.appendChild(createReviewBottom);
            
            createTestimonialsColumn.appendChild(createTestimonialsColumnDiv);
          createTestimonialsContainer.appendChild(createTestimonialsColumn);
          });
    
        createTesimonialsBanner.appendChild(createTestimonialsContainer);
      
      containerBottom.appendChild(createTesimonialsBanner);
    //========> END TESTIMONIALS BANNER
      
      createResultsContainer.appendChild(containerTop);
      createResultsContainer.appendChild(containerLeft);
      createResultsContainer.appendChild(containerRight);
      createResultsContainer.appendChild(containerBottom);
    quizContainer.appendChild(createResultsContainer);

    setTimeout(() => {
      createResultsContainer.style.marginLeft = "0vw";
    }, 600);
    //========> CONFETTI
    // setTimeout(() => {startConfetti();}, 1200);
    // setTimeout(() => {stopConfetti();}, 6000);
});
